import { render, staticRenderFns } from "./eAttrVal.vue?vue&type=template&id=70f8366c&scoped=true"
import script from "./eAttrVal.vue?vue&type=script&lang=js"
export * from "./eAttrVal.vue?vue&type=script&lang=js"
import style0 from "./eAttrVal.vue?vue&type=style&index=0&id=70f8366c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f8366c",
  null
  
)

export default component.exports